export let regularExpression = {
  // Validation for no special characters allow blackspace

  noSpecialCharacters: /[^a-zA-Z0-9\u00C0-\u017F\s ]/,
  emailFormat:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
